import { RETRYABLE } from './retryable';
import { timeoutPromise } from './timoutPromise';
import { Logger } from '../services';

// ESERVICE_UNAVAILABLE (HTTP 503) uses a long base delay to survive maintenance windows.
// All other retryable codes use a short base delay for fast network-blip recovery.
const LONG_RETRY_CODES = ['ESERVICE_UNAVAILABLE'];
const MAX_TRIES = 5;
const SHORT_BASE_DELAY_MS = 100;
const LONG_BASE_DELAY_MS = 30_000;

export async function promiseRetry(
  promiseGenerator: () => PromiseLike<any>,
  logger?: Logger,
) {
  let tries = 0;

  while (true) {
    try {
      return await promiseGenerator();
    } catch (err) {
      tries++;

      const errCode = err.code || (err.cause && err.cause.code);

      if (!RETRYABLE.includes(errCode) || tries >= MAX_TRIES) {
        throw err;
      }

      const baseDelay = LONG_RETRY_CODES.includes(errCode)
        ? LONG_BASE_DELAY_MS
        : SHORT_BASE_DELAY_MS;
      const delay = 2 ** tries * baseDelay;

      if (logger) {
        logger(
          `retry promise after error ${errCode} in ${delay}ms ( ${tries} tries )`,
        );
      }

      await timeoutPromise(delay);
    }
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/util/promiseRetry.ts